import { Icon } from "@iconify/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../Shared/Loading";

const SuperAdminConfirmOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axios.get("https://servercareseebd.careseebd.com/api/v1/orders");
      const pendingOrders = response.data.filter(
        (order) => order.status === "Confirm"
      );
      setOrders(pendingOrders);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleDeleteOrder = async (orderId) => {
    try {
      await axios.delete(`https://servercareseebd.careseebd.com/api/v1/orders/${orderId}`);
      fetchOrders();
      toast.success("Order deleted successfully");
    } catch (error) {
      console.error("Error deleting order:", error);
      toast.error("Error deleting order");
    }
  };

  return (
    <div className="space-y-6 select-none">
      {/* Header card */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight flex items-center gap-2">
            <Icon icon="solar:check-circle-bold" className="text-emerald-500 w-6 h-6" />
            Confirmed Orders List
          </h1>
          <p className="text-[11px] text-slate-400 font-bold mt-1 uppercase tracking-wider">Processed and verified purchases</p>
        </div>
        <div className="bg-emerald-50 border border-emerald-100 rounded-xl px-4 py-2 text-emerald-700 font-bold text-xs">
          Confirmed: <span className="text-emerald-900 font-black ml-1">{orders.length}</span>
        </div>
      </div>

      {/* Orders Table Container */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          {loading ? (
            <div className="py-20 flex justify-center items-center">
              <Loading />
            </div>
          ) : (
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-50/75 border-b border-slate-100">
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Client Name</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Phone</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">E-mail</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Address</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {orders.length > 0 ? (
                  orders.slice().reverse().map((order) => {
                    const clientName = order?.name || (order?.firstName ? `${order.firstName} ${order.lastName || ""}` : "N/A");
                    const clientEmail = order?.email || order?.emailAddress || "N/A";
                    const clientAddress = order?.address || order?.streetAddress || "N/A";

                    return (
                      <tr key={order._id} className="hover:bg-slate-50/50 transition-colors">
                        <td className="px-6 py-4 text-xs font-bold text-slate-800">
                          {clientName}
                        </td>
                        <td className="px-6 py-4 text-xs font-medium text-slate-500">
                          {order?.phone || "N/A"}
                        </td>
                        <td className="px-6 py-4 text-xs font-medium text-slate-500">
                          {clientEmail}
                        </td>
                        <td className="px-6 py-4 text-xs font-medium text-slate-500 max-w-xs truncate">
                          {clientAddress}
                        </td>
                        <td className="px-6 py-4 text-xs">
                          <span className="bg-emerald-50 text-emerald-700 font-bold px-2.5 py-0.5 rounded-full text-[10px] tracking-wide uppercase border border-emerald-100">
                            {order?.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-xs">
                          <div className="flex justify-end items-center gap-2">
                            <Link
                              to={`/superAdminDashboard/superadmin-order-view/${order._id}`}
                              className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 border border-slate-200 hover:border-indigo-150 rounded-lg transition-all cursor-pointer"
                              title="Review Invoice"
                            >
                              <Icon icon="grommet-icons:view" className="w-4 h-4" />
                            </Link>
                            <button
                              onClick={() => handleDeleteOrder(order._id)}
                              className="p-1.5 text-slate-400 hover:text-rose-600 hover:bg-rose-50 border border-slate-200 hover:border-rose-150 rounded-lg transition-all cursor-pointer"
                              title="Delete Record"
                            >
                              <Icon icon="material-symbols:delete-outline" className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-10 text-xs text-slate-400">
                      No confirmed orders.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminConfirmOrder;
